<template>
  <v-container fluid>
    <v-card flat class="my-5 elevation-0" height="100%">
      <v-card-title>
        Historical Results
        <v-spacer />
        <v-btn small color="primary" @click="downloadLink(file)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2">
          <v-card-text class="elevation-1 my-1">
            <pdf
              v-for="i in pageCount(fileBase64)"
              :key="i"
              style="width: 100%"
              :src="file"
              :page="i"
            />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import { AuthService } from "@/packages/dashboard/modules/auth";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "HistoricalResultsCard",
  mixins: [FileMixin],
  components: { pdf },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("Exam/getHistoricalTranscript", {
        studentNo: AuthService.user.student_no,
      });
      window.document.title = "KISEB::Historical Results";
    });
  },
  data: function () {
    return {
      file: "",
      fileBase64: "",
    };
  },
  computed: {
    transcript() {
      return this.$store.getters["Exam/studentExamGetter"]("transcript");
    },
  },
  methods: {
    timetableBase64: async function (file) {
      const blob = await helper.getFileBlob(file, "Timetable");
      return await helper.toBase64(blob);
    },
  },
  watch: {
    transcript() {
      if (this.transcript.isFile) {
        this.file = process.env.VUE_APP_TEMP_URL + this.transcript.res;
        this.timetableBase64(this.file).then((res) => {
          this.fileBase64 = res.split(",")[1];
        });
      } else {
        this.$alert({
          title: "Unable to display results",
          text: this.transcript.res,
          onClose: () => {
            this.$router.replace({ path: "/" });
          },
        });
      }
    },
  },
};
</script>

<style scoped></style>
